export const WX_MINI_PROGRAM_HOME_PATH = '/pages/index/index';
export const WX_MINI_PROGRAM_BANNER_DISMISSED_KEY =
  'wx-mini-program-banner-dismissed';

interface ShouldShowWxMiniProgramBannerOptions {
  userAgent: string;
  dismissed: boolean;
}

export function shouldShowWxMiniProgramBanner({
  userAgent,
  dismissed,
}: ShouldShowWxMiniProgramBannerOptions): boolean {
  return /MicroMessenger/i.test(userAgent) && !dismissed;
}
